// src/components/Events/NewYear/hooks/useNewYearEvent.js
import { useEffect, useRef, useState } from "react";
import api from "../../../../api/axios";

export default function useNewYearEvent(pushMatrixText) {
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [messages, setMessages] = useState([]);


    const burstTimerRef = useRef(null);

    // active 로드
    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                setLoading(true);
                const res = await api.get("/api/events/newyear/active/");
                if (!mounted) return;
                const ev = res.data?.event ?? res.data ?? null;
                setEvent(ev || null);
            } catch (e) {
                console.error(e);
                if (mounted) setEvent(null);
            } finally {
                if (mounted) setLoading(false);
            }
        })();

        return () => { mounted = false; };
    }, []);

    // 초기 메시지 + burst
    useEffect(() => {
        let mounted = true;
        if (!event) return;

        (async () => {
            try {
                const limit = 120;
                const res = await api.get(`/api/events/newyear/messages/?limit=${limit}`);
                if (!mounted) return;

                const raw = Array.isArray(res.data?.messages) ? res.data.messages : [];
                const msgs = raw.map((m) => ({
                    id: m.id,
                    content: m.content ?? m.text ?? "",
                    display_name: m.display_name ?? "",
                    created_at: m.created_at ?? "",
                }));

                setMessages(msgs);


            } catch (e) {
                console.error(e);
            }
        })();

        return () => {
            mounted = false;
            if (burstTimerRef.current) {
                clearInterval(burstTimerRef.current);
                burstTimerRef.current = null;
            }
        };
    }, [event, pushMatrixText]);

    return { event, loading, messages, setMessages };
}
